import { IconButton, Menu, Tooltip } from '@material-ui/core';
import React, { forwardRef } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { blue, red } from '@material-ui/core/colors';
import Images from 'assets/img';
import TextIcon from './components/TextIcon';
import { Container, MenuButtons } from './styles';
import BadgeStatus from './components/BadgeStatus';
import BadgeStatusDocumento from './components/BadgeStatusDocumento';
import {
  capitalize,
  getWeight,
  getImgType,
  formatDate,
  getValue,
} from '../../helpers';
import PopupMenu from './components/PopupMenu';
import MdfeMenu from './components/MdfeMenu';

export default function ChargeItem({
  selected,
  selectedUser,
  viewConvocation,
  data,
  tooglePercurseLogs,
  onEmitirMdfe,
  onConsultarMdfe,
  onCancelarMdfe,
  onEncerrarMdfe,
  onBaixarPdfMdfe,
  onBaixarXmlMdfe,
  onSincronizarMdfe,
  useSimplifiedMenu = false,
  MdfeMenuComponent = MdfeMenu,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log(data);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  function getStatus(status) {
    switch (status) {
      case 'in_progress_req':
        return (
          <BadgeStatus
            icon={Images.ChargeStatusOne}
            color="rgba(137, 70, 160, 0.4)"
            title="Motorista encontrado"
          />
        );
      case 'arrived_requester':
        return (
          <BadgeStatus
            icon={Images.ChargeStatusTwo}
            color="rgba(240, 151, 2, 0.4)"
            title="Carga encontrada"
          />
        );
      case 'in_progress_res':
        return (
          <BadgeStatus
            icon={Images.ChargeStatusThree}
            color="rgba(112, 180, 242, 0.4)"
            title="A caminho"
          />
        );
      case 'completed':
        return (
          <BadgeStatus
            icon={Images.ChargeStatusFive}
            color="#2A5BA8"
            title="Carga finalizada"
          />
        );
      default:
        return (
          <BadgeStatus icon={Images.ChargeStatusZero} title="Não iniciada" />
        );
    }
  }

  const handleDoubleClick = () => {
    // Duplo clique seleciona a carga
    if (viewConvocation) {
      viewConvocation(data);
    }
  };


  return (
    <Container onDoubleClick={handleDoubleClick} style={{ cursor: 'pointer' }}>
      <div className="imgs">
        {getStatus(data.status)}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
          {data.documentoStatus && (
            <BadgeStatusDocumento status={data.documentoStatus} />
          )}
          <Tooltip title={data.type}>
            <img src={getImgType(data.type)} alt="" />
          </Tooltip>
        </div>
      </div>
      <div className="informations">
        <div className="type-name">
          <h4>{data.requester ?? data.owner}</h4>
          <h5>{data?.condutores?.[0]?.nome ?? data?.driver_name ?? ''}</h5>
        </div>
        <div className="info">
          <TextIcon
            icon={Images.IconDate}
            text={formatDate(data.created_at) + ' -' + `${capitalize(data.nome_municipio_descarregamento)}, ${data.uf_descarregamento}`}
          />
          {data.status !== 'initial' ? (
            <div className="driver">
              <TextIcon icon={Images.IconDriver} text={data.driver_name} />
            </div>
          ) : null}
        </div>
      </div>
      <div className="menu">
        <MdfeMenuComponent 
          data={data}
          onEmitir={onEmitirMdfe}
          onConsultar={onConsultarMdfe}
          onCancelar={onCancelarMdfe}
          onEncerrar={onEncerrarMdfe}
          onBaixarPdf={onBaixarPdfMdfe}
          onBaixarXml={onBaixarXmlMdfe}
          onSincronizar={onSincronizarMdfe}
        />
        {!useSimplifiedMenu && (
          <PopupMenu
            tooglePercurseLogs={tooglePercurseLogs}
            viewConvocation={viewConvocation}
            data={data}
            selected={selected}
            anchorEl={anchorEl}
            open={open}
            handleClick={handleClick}
            handleClose={handleClose}
          />
        )}
      </div>
    </Container>
  );
}
